<mat-toolbar class="fullscreen-toolbar" color="primary" mat-dialog-title>
  <mat-toolbar-row><h3>Confirm Deletion</h3></mat-toolbar-row>
</mat-toolbar>
<mat-dialog-content class="fullscreen-dialog">
  <p>Are you sure you wish to delete this view?</p>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-dialog-close mat-flat-button type="reset">{{ 'scheduler.general.cancel' | translate }}</button>
    <button (click)="confirm()" color="warn" mat-raised-button type="submit">Delete</button>
</mat-dialog-actions>
